import { Configuration, RedirectRequest } from "@azure/msal-browser";
import logger from "@/utils/logger";

const notificationApiClientId = process.env.NEXT_PUBLIC_NOTIFICATION_CLIENT_ID;
const dispatchApiScope = process.env.NEXT_PUBLIC_DISPATCH_API_SCOPE;

if (!notificationApiClientId && process.env.NODE_ENV !== "test") {
    throw new Error(
        "FATAL ERROR: The NEXT_PUBLIC_NOTIFICATION_CLIENT_ID environment variable is missing. Please check your .env.local file and restart the server."
    );
}

if (!dispatchApiScope && process.env.NODE_ENV !== "test") {
    throw new Error(
        "FATAL ERROR: The NEXT_PUBLIC_DISPATCH_API_SCOPE environment variable is missing. Please check your .env.local file and restart the server."
    );
}

// Base scopes that we always need for login - including phone access
const baseScopes = ["User.Read", "profile", "email", "openid"];

// Scope for the notification API
const apiScopes = [`api://${notificationApiClientId}/user_impersonation`];

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.NEXT_PUBLIC_MSAL_CLIENT_ID || "YOUR_CLIENT_ID",
        authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_MSAL_TENANT_ID || "YOUR_TENANT_ID"}`,
        // 🔥 CRITICAL: Redirect to /auth which will redirect back to /
        redirectUri:
            process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI ||
            `${typeof window !== "undefined" ? window.location.origin : "http://localhost:3000"}/auth`,
        postLogoutRedirectUri:
            process.env.NEXT_PUBLIC_MSAL_POST_LOGOUT_REDIRECT_URI || "",
    },
    cache: {
        cacheLocation: "sessionStorage",
        temporaryCacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: 3, // Error = 0, Warning = 1, Info = 2, Verbose = 3
            loggerCallback: (
                level: number,
                message: string,
                containsPii: boolean
            ) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        logger.error(message);
                        return;
                    case 1:
                        logger.warn(message);
                        return;
                    case 2:
                        logger.info(message);
                        return;
                    case 3:
                        logger.debug(message);
                        return;
                    default:
                        logger.info(message);
                        return;
                }
            },
        },
    },
};

// Initial login request
export const loginRequest: RedirectRequest = {
    scopes: baseScopes,
};

export const dispatchApiRequest: RedirectRequest = {
    scopes: dispatchApiScope ? [dispatchApiScope] : [],
};

// Notification API request
export const notificationRequest: RedirectRequest = {
    scopes: apiScopes,
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
